import {Category} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/category.types';
import {useHistory, useIsCategoryPage} from '@aboutyou/router';
import {useCallback} from 'react';
import {CRM_COUPON_TOKEN_PARAM} from '../../Coupons/utils/crmCouponTokenParam';

export const useGetGenderSwitchTargetUrl = () => {
  const history = useHistory();
  const isCategoryPage = useIsCategoryPage();

  return useCallback(
    (category: Category, gender?: string) => {
      if (isCategoryPage) {
        const queryParams = new URLSearchParams(history.location.search);
        queryParams.delete(CRM_COUPON_TOKEN_PARAM);

        return {
          pathname: category.path,
          search: queryParams.toString(),
        };
      }

      const queryParams = new URLSearchParams(history.location.search);
      queryParams.delete(CRM_COUPON_TOKEN_PARAM);

      queryParams.delete('category');
      queryParams.append('category', `${category.id}`);

      if (gender) {
        queryParams.delete('gender');
        queryParams.append('gender', gender);
      }

      return {
        pathname: history.location.pathname,
        search: queryParams.toString(),
      };
    },
    [history.location.pathname, history.location.search],
  );
};
